import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IonicModule } from '@ionic/angular'
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TooltipModule } from '@syncfusion/ej2-angular-popups'
import { NgxFloatUiModule } from 'ngx-float-ui'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    IonicModule,
    DateTimePickerModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    NgxFloatUiModule,
    FontAwesomeModule,
  ],
  exports: [],
})
export class AssistantSelectModule {}
